import { LayerProperty } from 'cadenza/map/layer-property';
import { MapProperty } from 'cadenza/map/map-property';
import Interaction from 'ol/interaction/Interaction';
import { FeatureAttributesPanel } from 'cadenza/map/feature-attributes-panel/feature-attributes-panel';
import { isPanelAlreadyOpen } from 'cadenza/map/feature-attributes-panel/abstract-feature-panel';
import { addSidebar } from 'cadenza/map/map-utils';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { LayerAction } from './layer-action';

export class FeatureEditAttributes extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('featureEditor.editAttributes')
    }, options));
    this.#map = options.map;
  }

  executeSync () {
    const previousPrimaryInteraction = this.#map.get(MapProperty.PRIMARY_INTERACTION);

    this.#map.set(MapProperty.PRIMARY_INTERACTION, new DummyEditAttributesInteraction());
    const featureAttributesPanel = new FeatureAttributesPanel({
      map: this.#map,
      layer: this.layer,
      onClose: () => {
        this.checkIfActionIsSupported();
        this.#map.set(MapProperty.PRIMARY_INTERACTION, previousPrimaryInteraction);
      }
    });
    addSidebar(featureAttributesPanel);
    this.checkIfActionIsSupported();
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isPanelAlreadyOpen()
      && !isEditingLayer
      && this._layer.get(LayerProperty.HAS_FEATURES)
      && this._layer.get(LayerProperty.SELECTED_FEATURE_IDS).length > 0
      && this._layer.get(LayerProperty.SUPPORTS_ATTRIBUTES_EDIT);
  }

  requiresObjectSelection () {
    return true;
  }

}

class DummyEditAttributesInteraction extends Interaction {

  constructor () {
    super({});
  }

}
